const validateReq = (res, place) => {
    res === "error" && alert("Error: " + place)
}

export default validateReq